import { Notify } from 'quasar'

const actions = {
  FETCH_ERROR (context, payload) {
    if (payload?.response?.data?.details) {
      payload.response.data.details.forEach((error, index) => {
        if (index < 5) {
          Notify.create({
            message: error.message,
            color: 'red'
          })
        }
      })
    } else {
      let message
      // TELL ME WHYYYYYYY....?????? GOKIEEELL

      if (typeof payload === 'string') {
        message = payload
      } else {
        if (payload?.message) {
          message = payload.message
        }

        if (payload?.response?.data) {
          if (payload.response.data?.message) {
            message = payload.response.data.message
          } else if (payload.response.data?.msg) {
            if (typeof payload.response.data.msg === 'string') {
              message = payload.response.data.msg
            } else {
              if (Array.isArray(payload.response.data.msg)) {
                message = payload.response.data.msg[0].message
              } else {
                const getObject = (Object.keys(payload.response.data.msg))

                if (getObject.includes('error')) {
                  message = payload.response.data.msg?.error?.message
                } else if (getObject.includes('details')) {
                  message = payload.response.data.msg?.details[0].message
                }
              }
            }
          } else if (payload.response.data?.error) {
            message = payload?.response?.data?.error?.printMsg ? payload?.response?.data?.error?.printMsg : 'Something went wrong'
          }
        }
      }

      Notify.create({
        type: 'negative',
        icon: 'cancel',
        message,
        html: true
      })
    }
  },

  FETCH_WARNING (context, payload) {
    let message

    if (typeof payload === 'string') {
      message = payload
    } else if (Array.isArray(payload.response?.data)) {
      message = payload.response.data[0].message
    } else if (payload.response?.data?.message) {
      message = payload.response.data.message
    } else if (payload.response?.data?.msg) {
      message = payload.response.data.msg
    } else if (payload.response?.data?.error?.printMsg) {
      message = payload.response.data.error.printMsg
    } else {
      message = payload.message
    }

    Notify.create({
      message,
      textColor: 'teal-9',
      color: 'teal-2'
    })
  },
  FETCH_SUCCESS (context, payload) {
    const message = payload.data?.message
      ? payload.data.message
      : payload.message

    Notify.create({
      message,
      color: 'green'
    })
  }
}

export default {
  namespaced: true,
  actions
}
